<div class="row">
  <div class="col-xs-12 col-12 col-sm-6 col-md-4 form-group">
    <input type="text" class="form-control" placeholder="Datepicker" bsDatepicker [(ngModel)]="datepickerModel" />
  </div>
  <div class="col-xs-12 col-12 col-sm-6 col-md-4 form-group">
    <input type="text" class="form-control" placeholder="Daterangepicker" bsDaterangepicker [(ngModel)]="daterangepickerModel" />
  </div>
</div>
<div class="row">
  <div class="col-xs-12 col-md-12">
    <pre class="code-preview">{{datepickerModel}}<br>{{daterangepickerModel}}</pre>
  </div>
</div>


